import React, { useState, useEffect } from 'react';
import { FaBirthdayCake, FaTimes } from 'react-icons/fa';

const AgeVerification: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const verified = localStorage.getItem('ageVerified');
    if (!verified) {
      setShow(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setShow(false);
  };

  const handleDecline = () => {
    window.location.href = 'https://www.gamcare.org.uk/';
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-8 relative fade-in zoom-in">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-primary-100 rounded-full p-4">
              <FaBirthdayCake className="text-4xl text-primary-600" />
            </div>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Age Verification Required
          </h2>
          <p className="text-gray-600 mb-6">
            You must be 18 or older to access this website. By clicking "I am 18+" you confirm that you are of legal gambling age in your jurisdiction.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={handleConfirm}
              className="flex-1 bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200"
            >
              I am 18+
            </button>
            <button
              onClick={handleDecline}
              className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-3 px-6 rounded-lg transition-colors duration-200"
            >
              I am under 18
            </button>
          </div>
          <p className="text-xs text-gray-500 mt-6">
            Responsible gambling is important. If you need help, visit{' '}
            <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline">
              GamCare
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;

